import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Features from './pages/Features';
import Commands from './pages/Commands';
import Policy from './pages/Policy';
import ToS from './pages/ToS';

function App() {
    return (
        <Router>
            <div className="min-h-screen bg-gray-200 flex justify-center p-8 pt-[100px]">
                <div className="flex flex-col gap-5 w-full max-w-4xl">
                    {/* Logo */}
                    <div className="flex justify-center mb-4">
                        <img
                            src="https://habbofont.net/font/habbo_old_big/originsbot.gif"
                            alt="OriginsBot Logo"
                            className="w-auto h-auto"
                        />
                    </div>

                    {/* Navigation Box */}
                    <div className="bg-white border border-gray-300 rounded-lg shadow-md p-6">
                        <nav className="flex justify-center gap-4 flex-wrap">
                            <Link to="/" className="px-6 py-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
                                Home
                            </Link>
                            <Link to="/features" className="px-6 py-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
                                Features
                            </Link>
                            <Link to="/commands" className="px-6 py-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
                                Commands
                            </Link>
                            <Link to="/privacy" className="px-6 py-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
                                Privacy Policy
                            </Link>
                            <Link to="/terms" className="px-6 py-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
                                Terms of Service
                            </Link>
                        </nav>
                    </div>

                    {/* Content Box */}
                    <div className="bg-white border border-gray-300 rounded-lg shadow-md p-8">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/features" element={<Features />} />
                            <Route path="/commands" element={<Commands />} />
                            <Route path="/privacy" element={<Policy />} />
                            <Route path="/terms" element={<ToS />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </Router>
    );
}

export default App;